"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _dimensions = require("../utils/dimensions");

var _divider = require("./divider.styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  x: 0,
  y: 0,
  height: 1,
  align: 'center'
};

const Divider = ({
  height,
  x,
  y,
  align,
  children,
  textColor,
  css,
  ...props
}) => {
  const alignCss = (0, _react.useMemo)(() => {
    if (!align || align === 'center') return '';

    if (align === 'left' || align === 'start') {
      return {
        transform: 'translateY(-50%)',
        left: '7%'
      };
    }

    return {
      transform: 'translateY(-50%)',
      left: 'auto',
      right: '7%'
    };
  }, [align]);
  const top = y ? (0, _dimensions.getMargin)(y / 2) : 0;
  const left = x ? (0, _dimensions.getMargin)(x / 2) : 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_divider.StyledDivider, {
    role: "separator",
    css: {
      margin: `${top} ${left}`,
      height: `calc(${height} * 1px)`,
      ...css
    },
    ...props,
    children: children && /*#__PURE__*/(0, _jsxRuntime.jsx)(_divider.StyledDividerText, {
      css: { ...alignCss
      },
      color: textColor,
      className: "nextui-divider-text",
      children: children
    })
  });
};

Divider.toString = () => '.nextui-divider';

const MemoDivider = /*#__PURE__*/_react.default.memo(Divider);

var _default = (0, _withDefaults.default)(MemoDivider, defaultProps);

exports.default = _default;
module.exports = exports.default;